import { render, staticRenderFns } from "./CovidStats.vue?vue&type=template&id=656dc482&scoped=true&"
import script from "./CovidStats.vue?vue&type=script&lang=js&"
export * from "./CovidStats.vue?vue&type=script&lang=js&"
import style0 from "./CovidStats.vue?vue&type=style&index=0&id=656dc482&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656dc482",
  null
  
)

export default component.exports